<mat-drawer-container class="administration-layout" autosize [hasBackdrop]="true">
    <mat-drawer
        #filterDrawer
        class="administration-layout__filter"
        [disableClose]="filterDrawerDisableClose"
        position="end"
        mode="over"
        [opened]="false"
    >
        <app-filter-drawer [filterDrawer]="filterDrawer" (disableClose)="filterDrawerDisableClose = $event"></app-filter-drawer>
    </mat-drawer>
    <app-header [userDetails]="userDetails"></app-header>
    <app-footer></app-footer>
    <app-installation-prompt></app-installation-prompt>
</mat-drawer-container>
